import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import {
  deleteCaseZoningPlanQuery,
  fetchCaseZoningPlansQuery,
} from 'app/edozvola/cases/case-zoning-plan-compliance/service/case-zoning-plan-compliance.queries';
import { CaseZoningPlanViewModel } from 'app/edozvola/cases/case-zoning-plan-compliance/model/case-zoning-plan-compliance.model';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

interface CaseZoningPlanTableProps {
  finalActIssued: boolean;
}

const CaseZoningPlanTable = ({ finalActIssued }: CaseZoningPlanTableProps) => {
  const { id: uuid } = useParams<{ id: string }>();
  const [idZoningPlanToDelete, setIdZoningPlanToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const { mutate: deleteZoningPlan, isPending: deletingZoningPlan } = deleteCaseZoningPlanQuery();

  const openDeleteDialog = idToDelete => {
    setIdZoningPlanToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const removeCaseZoningPlan = () => {
    setDeleteModalShown(false);
    deleteZoningPlan(idZoningPlanToDelete);
  };

  const renderTableRow = (value: CaseZoningPlanViewModel, caseZoningPlanIndex: number, totalItems: number) => {
    return (
      <tr key={caseZoningPlanIndex}>
        <td>
          <span>{value.mark}</span>
          <br />
          <span>{value.name}</span>
        </td>
        <td>{value.bulletin}</td>
        <td>
          <span>{value.revisionMark}</span>
          <br />
          <span>{value.revisionName}</span>
        </td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canDelete && finalActIssued && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon icon={'trash-alt'} className={'icon-table'} onClick={() => openDeleteDialog(value.idCaseZoningPlanMap)} />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema prostornih planova.'}
        initialPaginationColumn={'mark'}
        fetchDataQuery={fetchCaseZoningPlansQuery}
        fetchDataProps={[uuid]}
      >
        <ViewTableHeaderColumn renderSort sortKey={'mark'} columnLabels={['Oznaka plana', 'Naziv prostornog plana']} width={'200px'} />
        <ViewTableHeaderColumn renderSort sortKey={'bulletin'} columnLabels={['Naziv i broj službenog glasila']} width={'200px'} />
        <ViewTableHeaderColumn
          renderSort
          sortKey={'revisionMark'}
          columnLabels={['Oznaka revizije plana', 'Naziv revizije plana']}
          width={'200px'}
        />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'120px'} />
      </ViewTable>
      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje prostornog plana</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} color={'secondary'} />
          <Button size={'lg'} label="Obriši" onClick={removeCaseZoningPlan} color={'danger'} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CaseZoningPlanTable;
